import { logInfo } from "./log";

const getConstants = async () => {
  const response = await fetch(
    `constants`
  );
  const data = await response.json();
  return data;
};

const getBackgrounds = async (artCreationPackId) => {
  const response = await fetch(
    `/artCreationPack/${artCreationPackId}/backgrounds`
  );
  const data = await response.json();
  return data;
};

const getPatterns = async (artCreationPackId) => {
  const response = await fetch(
    `/artCreationPack/${artCreationPackId}/patterns`
  );
  const data = await response.json();
  return data;
};

const getLayers = async (artCreationPackId, patternId) => {
  const response = await fetch(
    `/artCreationPack/${artCreationPackId}/pattern/${patternId}/layers`
  );
  const data = await response.json();
  return data;
};

const getLayerChoices = async (artCreationPackId, patternId, layerId) => {
  const response = await fetch(
    `/artCreationPack/${artCreationPackId}/pattern/${patternId}/layer/${layerId}/layerchoices`
  );
  const data = await response.json();
  return data;
};

const getApprovedNames = async (artCreationPackId) => {
  const response = await fetch(
    `/artCreationPack/${artCreationPackId}/approvednames`
  );
  const data = await response.json();
  return data;
};

const getPresetDistribution = async (siteId) => {
  const response = await fetch(`/site/${siteId}/presetdistribution`);
  const data = await response.json();
  return data;
};

const getRarityList = async (siteId) => {
  const response = await fetch(`/site/${siteId}/raritydetails`);
  const data = await response.json();
  return data;
};

const isApproved = async () => {
  const response = await fetch(`/site/approved`);
  const data = await response.json();
  return data;
};

const getSite = async () => {
  const response = await fetch(`/site`);
  const data = await response.json();
  return data;
};

const getSiteDistribution = async (siteDetails) => {
  const response = await fetch(`/site/distribution`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(siteDetails),
  });
  const data = await response.json();
  return data;
};

const getFilterData = async (siteDetails) => {
  const response = await fetch(
    `artCreationPack/${siteDetails.artCreationPackId}/getfilterData`
  );
  const data = await response.json();
  return data;
};

const getBuyNFT = (walletAddress, page, limit) => {
  const pagination = page && limit ? `?page=${page}&limit=${limit}` : "";
  const controller = new AbortController();
  const signal = controller.signal;
  const promise = new Promise(async (resolve) => {
    try {
      const response = await fetch(
        `/fundraisin/buy-nft/${walletAddress}${pagination}`,
        {
          method: "get",
          signal,
        }
      );
      const data = await response.json();
      resolve(data);
    } catch (error) {
      if (error && error.name === "AbortError") {
        logInfo(`IGNORE: ${error.message}`);
      }
    }
  });
  promise.cancel = () => controller.abort();
  return promise;
};

const getTokenOwner = async (tokenId) => {
  const response = await fetch(`/fundraisin/token/${tokenId}/owner`);
  const data = await response.text();
  return data;
};

const getTopFundraiser = async (walletAddress) => {
  const response = await fetch(`/fundraisin/top-nft/${walletAddress}`);
  const data = await response.json();
  return data;
};

const getMyNFT = async (walletAddress) => {
  const response = await fetch(`/fundraisin/my-nft/${walletAddress}`);
  const data = await response.json();
  return data;
};

export {
  getConstants,
  getBackgrounds,
  getPatterns,
  getLayers,
  getLayerChoices,
  getApprovedNames,
  getPresetDistribution,
  getRarityList,
  isApproved,
  getSite,
  getSiteDistribution,
  getFilterData,
  getBuyNFT,
  getTopFundraiser,
  getMyNFT,
  getTokenOwner,
};
